"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireDefault(require("./../../../Modal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable @typescript-eslint/no-require-imports */


var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;

function Render(props) {
  var _a = props || {},
      styleChild = _a.styleChild,
      title = _a.title,
      leftTitle = _a.leftTitle,
      leftDesc = _a.leftDesc,
      leftMore = _a.leftMore,
      lefttxtList = _a.lefttxtList,
      leftNum = _a.leftNum,
      onCallback = _a.onCallback,
      extendProps = _a.extendProps,
      btnTxt = _a.btnTxt,
      rightList = _a.rightList,
      modalConfiguration = _a.modalConfiguration;

  var _b = modalConfiguration || {},
      list = _b.list,
      modalTitle = _b.modalTitle,
      richTextContent = _b.richTextContent;

  var _c = (0, _react.useState)(''),
      modalContent = _c[0],
      setModalContent = _c[1];

  var _d = (0, _react.useState)(false),
      status = _d[0],
      setStatus = _d[1];

  var _e = (0, _react.useState)({}),
      modalList = _e[0],
      setModalList = _e[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits-container__child'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ex-benefits-title'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ex-benefits-container',
    style: (0, _typeof2["default"])(styleChild) === 'object' ? styleChild : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ex-benefits-container__child'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__left__head'
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'strong'
  }, leftTitle), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'strong-desc'
  }, leftDesc), /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'strong-more',
    onClick: function onClick() {
      setStatus(true);
      setModalList({
        list: list,
        modalTitle: modalTitle
      });
      setModalContent(richTextContent);
    }
  }, extendProps || {}), leftMore), /*#__PURE__*/_react["default"].createElement("img", {
    src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/fwbd356_giftoutput%201.png',
    alt: leftTitle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__left--expend'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'exclusive-benefits__left__ul'
  }, lefttxtList === null || lefttxtList === void 0 ? void 0 : lefttxtList.map(function (item, index) {
    var txt = (item || {}).txt;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: 'exclusive-benefits__left__ul__li'
    }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, null), txt);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__left__number'
  }, "$", /*#__PURE__*/_react["default"].createElement("span", null, leftNum)), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: 'exclusive-benefits__left__button',
    val: btnTxt,
    // style={{
    //   backgroundImage: `url(https://staticintl.cloudcachetci.com/cms/backend-cms/ydrH809_btn.png)`,
    // }}
    onClick: function onClick() {
      onCallback && onCallback();
    }
  }, extendProps || {}), btnTxt))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__right'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'exclusive-benefits__right__ul'
  }, rightList === null || rightList === void 0 ? void 0 : rightList.map(function (item, index) {
    var title = item.title,
        desc = item.desc,
        txt = item.txt,
        href = item.href,
        buttonConfig = item.buttonConfig,
        moreExtendProps = item.moreExtendProps;

    var _a = buttonConfig || {},
        text = _a.text,
        onCallback = _a.onCallback,
        btnExtendProps = _a.btnExtendProps;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'exclusive-benefits__right__ul__li',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'exclusive-benefits__right__ul__li--container'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'title'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'txt'
    }, title)), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'desc'
    }, desc), /*#__PURE__*/_react["default"].createElement("a", __assign({
      className: 'a',
      href: href
    }, moreExtendProps || {}), txt), /*#__PURE__*/_react["default"].createElement("button", __assign({
      className: 'button',
      onClick: function onClick() {
        return onCallback();
      }
    }, btnExtendProps || {}), text), /*#__PURE__*/_react["default"].createElement("img", {
      className: 'img',
      src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/4IkT9_material07%2065.png',
      alt: title
    })));
  }))))), status && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    close: function close() {
      setStatus(false);
    },
    submit: function submit() {
      setStatus(false);
    },
    modalList: modalList,
    modalContent: modalContent
  }));
}

function ExclusiveBenefits(props) {
  var _a = props || {},
      _b = _a.style,
      style = _b === void 0 ? {} : _b,
      _c = _a.styleChild,
      styleChild = _c === void 0 ? {} : _c,
      title = _a.title,
      leftTitle = _a.leftTitle,
      leftDesc = _a.leftDesc,
      leftMore = _a.leftMore,
      lefttxtList = _a.lefttxtList,
      leftNum = _a.leftNum,
      onCallback = _a.onCallback,
      extendProps = _a.extendProps,
      btnTxt = _a.btnTxt,
      rightList = _a.rightList,
      modalConfiguration = _a.modalConfiguration;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {},
    className: 'exclusive-benefits-container exclusive-benefits-container--pc'
  }, /*#__PURE__*/_react["default"].createElement(Render, {
    styleChild: styleChild,
    title: title,
    leftTitle: leftTitle,
    leftDesc: leftDesc,
    leftMore: leftMore,
    lefttxtList: lefttxtList,
    leftNum: leftNum,
    onCallback: onCallback,
    extendProps: extendProps,
    btnTxt: btnTxt,
    rightList: rightList,
    modalConfiguration: modalConfiguration
  })), /*#__PURE__*/_react["default"].createElement("section", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {},
    className: 'exclusive-benefits-container  exclusive-benefits-container-mobile'
  }, /*#__PURE__*/_react["default"].createElement(Render, {
    styleChild: styleChild,
    title: title,
    leftTitle: leftTitle,
    leftDesc: leftDesc,
    leftMore: leftMore,
    lefttxtList: lefttxtList,
    leftNum: leftNum,
    onCallback: onCallback,
    extendProps: extendProps,
    btnTxt: btnTxt,
    rightList: rightList,
    modalConfiguration: modalConfiguration
  })));
}

var _default = ExclusiveBenefits;
exports["default"] = _default;